import { render } from "./mainTable.vue?vue&type=template&id=42af244c&scoped=true"
import script from "./mainTable.vue?vue&type=script&lang=js"
export * from "./mainTable.vue?vue&type=script&lang=js"

import "./mainTable.vue?vue&type=style&index=0&id=42af244c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42af244c"]])

export default __exports__